import { motion, AnimatePresence } from "framer-motion";
import { nanoid } from "nanoid";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AppContext from "../AppContext";
import { setUserId } from "../widgetSlice";
import { Header } from "./Header";
import { Keypad } from "./Keypad";
import { Launcher } from "./Launcher";
import { Messages } from "./Messages";

export const WidgetLayout = (props) => {
  const dispatch = useDispatch();
  let { toggleWidget, userId: _userId } = useSelector(
    (state) => state.widgetState
  );
  let { onLogout, userId, embedded } = props;
  let userIdRef = useRef(_userId);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 570);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 570);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (userId) {
      userIdRef.current = userId;
    } else {
      if (!userIdRef.current) {
        userIdRef.current = nanoid();
        console.log(userIdRef.current);
        dispatch(setUserId(userIdRef.current));
      }
    }
  }, [dispatch, embedded, props.userId, toggleWidget, userId]);

  if (embedded) {
    return (
      <AppContext.Provider value={{ userId: userIdRef.current, ...props }}>
        <AnimatePresence>
          <div
            className="fixed flex h-full w-full flex-col rounded-[1.8rem]   bg-white  font-lato   shadow-md"
            key="widget"
          >
            <Header onLogout={onLogout} />
            <Messages onLogout={onLogout} />
            <Keypad onLogout={onLogout} />
          </div>
        </AnimatePresence>
      </AppContext.Provider>
    );
  }
  return (
    <AppContext.Provider value={{ userId: userIdRef.current, ...props }}>
      {toggleWidget ? (
        <div
          style={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            paddingRight: "1rem",
          }}
        >
          {isMobile ? (
            <div
              className=" flex-col rounded-[1.8rem] bg-white  font-lato   shadow-md"
              key="widget"
              style={{
                border: "1px solid rgb(200, 200, 200)",
                width: "100%",
                height: "100%",
                position: "absolute",
                right: 0,
                bottom: 0,

                zIndex: 1000,
              }}
            >
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  right: 0,
                  left: 0,
                  zIndex: 1000,
                  width: window.innerWidth,
                }}
              >
                <Header onLogout={onLogout} />
              </div>
              <div style={{ paddingTop: "5rem", paddingBottom: "3rem" }}>
                <Messages onLogout={onLogout} />
              </div>
              <div
                style={{
                  position: "fixed",
                  bottom: 0,
                  right: 0,
                  left: 0,
                  zIndex: 1000,
                  width: window.innerWidth,
                }}
              >
                <Keypad onLogout={onLogout} />
              </div>
            </div>
          ) : (
            <AnimatePresence>
              <motion.div
                className="flex flex-col rounded-[1.8rem] bg-white font-lato"
                key="widget"
                style={{
                  border: "1px solid rgb(200, 200, 200)",
                  width: "340px",
                  height: "94%",
                  zIndex: 2000,
                }}
              >
                <Header onLogout={onLogout} />
                <Messages onLogout={onLogout} />
                <Keypad onLogout={onLogout} />
              </motion.div>
            </AnimatePresence>
          )}
        </div>
      ) : (
        <Launcher />
      )}
    </AppContext.Provider>
  );
};
